import { FunctionComponent } from "react";
import ColorfulLoading from "../../images/ColorfulLoading";

interface IProps {
	message?: string;
}

const PageLoading: FunctionComponent<IProps> = (props) => {
	const { message } = props;

	return <div style={{ height: "70vh", display: "flex", alignItems: "center", marginTop: "20vh", flexDirection: "column" }}>
		<ColorfulLoading width="70%" height="70%" />
		{message ? <span>{message}</span> : null}
	</div>;
};

export default PageLoading;